import { createSelector } from 'reselect'

/** A Redux selector to retrieve communications
 * @param state - The Redux state
 * @param {Array} [] - The communications to fetch
 */

const getCommunications = (identifier: string, state: any) => state.communications[identifier] ? state.communications[identifier] : undefined

const getSyndication = (state: any, communicationId: number) => state.communications.syndication && state.communications.syndication[communicationId]
  ? state.communications.syndication[communicationId] : {}

export const selectCommunications = createSelector(
  getCommunications,
  (data) => data ? data.communications : []
)

/** A Redux selector to retrieve communications
 * @param state - The Redux state
 * @param {Number} - Indicated total communications.
 */

export const selectTotalCommunications = createSelector(
  getCommunications,
  (data) => data ? data.total : 0
)

/** A Redux selector to retrieve communications loading state
 * @param state - The Redux state
 * @param {Boolean} - Boolean value indicating whether Communications is being loaded.
 */

export const selectCommunicationsIsLoading = createSelector(
  getCommunications,
  (data) => data ? data.status.isLoading : false
)

/** A Redux selector to retrieve syndications
 * @param state - The Redux state
 * @param {Object} - Boolean value indicating whether Syndications is being loaded.
 */

export const selectSyndication = createSelector(
  getSyndication,
  (data) => data.syndication || null
)

/** A Redux selector to retrieve syndication loading state
 * @param state - The Redux state
 * @param {Boolean} - Boolean value indicating whether Syndication is being loaded.
 */

export const selectSyndicationLoading = createSelector(
  getSyndication,
  (data) => data.syndicationLoading || false
)

/** A Redux selector to retrieve syndication error state
 * @param state - The Redux state
 * @param {Boolean} - Boolean value indicating whether Syndication is being loaded.
 */

export const selectSyndicationError = createSelector(
  getSyndication,
  (data) => data.error || false
)
